var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.section},[_c('order-history'),_c('order-details'),_c('payment-drawer',{attrs:{"redirect-url":'profile/?frompayment=true&section=orders'}}),_c('overlay-content-loader',{attrs:{"is-loading":_vm.pageLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }